import VMasker from 'vanilla-masker'

export function maskPlate(plate: string) {
  return VMasker.toPattern(plate, "AAA-9S99").toUpperCase();
}